import React, {Fragment} from 'react';

import {GetHelpCenterArticleResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/help_center/v1/service.types';
import {Heading18, Heading32, Paragraph14} from '@aboutyou/ui-components';
import styled from 'styled-components';

interface HelpCenterArticleViewProps {
  article: GetHelpCenterArticleResponse['article'];
  isTitleFloating?: boolean;
}

export const HelpCenterArticleView: React.FC<HelpCenterArticleViewProps> = ({
  article,
  isTitleFloating = false,
}) => {
  const TitleComponent = isTitleFloating
    ? AbsolutelyPositionedTitle
    : TitleWithMargin;
  return (
    <Fragment>
      <TitleComponent as="h1">{article.title}</TitleComponent>
      <Content
        data-testid="HelpCenterArticleContent"
        as="div"
        dangerouslySetInnerHTML={{__html: article.description}}
      />
    </Fragment>
  );
};

const AbsolutelyPositionedTitle = styled(Heading18)`
  position: absolute;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  max-width: calc(100vw - 120px); // equivalent to the side paddings
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5rem;
  margin: 0;
`;

const TitleWithMargin = styled(Heading32)`
  margin: 32px 0px;
`;

const Content = styled(Paragraph14)`
  margin-bottom: 60px;
  max-width: 650px;

  iframe {
    width: 100%;
  }
`;
